import { CONTACT_US_LIST_FAIL, CONTACT_US_LIST_SUCCESS, CONTACT_US_REQUEST } from "../constants/contactUsContants";

const initialState = {
    loading: true,
    contactUsList: [],
    error: null,
    totalCount: 0,
};

export const ContactUsReducers = (state = initialState, action) => {
    switch (action.type) {
        case CONTACT_US_REQUEST:
            return { ...state, loading: true };

        case CONTACT_US_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                contactUsList: action.payload.contactUs,
                totalCount: action.payload.totalCount,
                error: null,
            };
        case CONTACT_US_LIST_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};